// component
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

const navConfig = [
  {
    title: 'dashboard',
    path: '/dashboard/app',
    icon: getIcon('eva:pie-chart-2-fill'),
  },
  {
    title: 'websites',
    path: '/dashboard/websites',
    icon: getIcon('gg:website'),
  },
  // {
  //   title: "hosting",
  //   path: "/dashboard/hosting",
  //   icon: getIcon("ant-design:cloud-filled")
  // },
  {
    title: 'lead center',
    path: '/dashboard/lead-center',
    icon: getIcon('eva:people-fill'),
  },
  {
    title: 'audiences',
    path: '/dashboard/audiences',
    icon: getIcon('eva:people-fill'),
  },
  // {
  //   title: "integration",
  //   path: "/dashboard/integration",
  //   icon: getIcon("eva:file-text-fill"),
  //   children: [
  //     { title: "Domain Integration", path: "/dashboard/integration/domains" },
  //     {
  //       title: "Payment Gateways",
  //       path: "/dashboard/integration/payment-gateways"
  //     },
  //     { title: "Timers", path: "/dashboard/integration/timers" },
  //     { title: "Heat Map Integration", path: "/dashboard/integration/heatmap" },
  //     {
  //       title: "Google Analytics Integration",
  //       path: "/dashboard/integration/google-analytics"
  //     },
  //     {
  //       title: "Google Tag Manager Integration",
  //       path: "/dashboard/integration/google-tag"
  //     },
  //     { title: "Fb Pixel Integration", path: "/dashboard/integration/fbpixel" },
  //     { title: "Whatsapp Chat Button", path: "/dashboard/integration/whatsapp" }
  //   ]
  // },
  {
    title: 'marketing',
    path: '/dashboard/campaigns',
    icon: getIcon('material-symbols:campaign'),
    children: [
      { title: 'Email Marketing', path: '/dashboard/campaigns/campaigns' },
      { title: 'Email templates', path: '/dashboard/campaigns/email-templates/new' },
      { title: 'WhatsApp Marketing', path: '/dashboard/coming-soon' },
      { title: 'SMS Marketing', path: '/dashboard/coming-soon' },
    ],
  },
  // {
  //   title: "Add-on services",
  //   path: "/dashboard/addons",
  //   icon: getIcon("ic:baseline-medical-services")
  // },
  // {
  //   title: "Hire Specialist",
  //   path: "/dashboard/specialists",
  //   icon: getIcon("la:hire-a-helper")
  // },
  {
    title: 'Wallet',
    path: '/dashboard/wallet',
    icon: getIcon('bi:wallet'),
  },
  {
    title: 'Help Center',
    path: '/dashboard/help',
    icon: getIcon('bx:help-circle'),
  },
];

export default navConfig;
